import { render, staticRenderFns } from "./application-description-form.vue?vue&type=template&id=0b86d2c9"
import script from "./application-description-form.vue?vue&type=script&lang=js"
export * from "./application-description-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports